module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_05_770_280_zh-hant-9435a02c9e5fa3ae89adbb6210e6f02d.jpg";